// extracted by mini-css-extract-plugin
export default {"heading3":"Heading3_heading3__bZAlw","heading3_white":"Heading3_heading3_white__-On3d"};